var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creditCardInfos"},[_c('div',{staticClass:"cardLogo"},[_c('font-awesome-icon',{staticClass:"fa-3x",attrs:{"icon":_vm.icons.cc[_vm.card.brand]}})],1),_c('div',{staticClass:"cardDescription"},[_c('div',{staticClass:"cardId"},[_vm._v(_vm._s(_vm.card.brand)+" •••• "+_vm._s(_vm.card.last4))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }